define.alias("shared/errors/invalid-credentials-error", "media/errors/invalid-credentials-error");